import { all, call, takeLatest, put } from 'redux-saga/effects'
import * as actions from './actions'
import * as services from './services'

export function * getPAchild ({ payload }) {
  try {
    const currentPage = payload.page || 1
    const response = yield call(services.getPAChild, payload)
    yield put(
      actions.getPAChildSuccessful({
        response,
        current_page: currentPage
      })
    )
  } catch (error) {
    yield put(actions.getPAChildFailure(error))
  }
}

function * watchFetchQueue () {
  yield takeLatest(actions.getPAChild, getPAchild)
}

export default function * pickupAuthorizationChildSagas () {
  yield all([watchFetchQueue()])
}
